import React, {Component} from 'react'
import Links from './Links'
import AlgoEditor from './AlgoEditor'

import style from './style.sass'

class Header extends Component {
  state = {
    editor: false
  }
  openEditor = () => {
    this.setState({editor:true})
  }
  closeEditor = () => {
    this.setState({editor:false})
  }
  render() {
    return(
      <div styleName='wrapper'>
        <h3>{this.props.title}</h3>
        <Links openEditor={this.openEditor} editor={this.state.editor}/>
        {this.state.editor &&
          <AlgoEditor close={this.closeEditor}/>
        }
      </div>
    )
  }
}

export default Header
